import { LOCAL_STORAGE_PREFIX } from 'const';
import React from 'react';

function useStateWithLocalStorage(localStorageKey) {
  const [value, setValue] = React.useState(GetItem());

  function GetItem() {
    const item = localStorage.getItem(LOCAL_STORAGE_PREFIX + localStorageKey);
    if (item === null || item === 'null')
      return null;
    else
      return item;
  }

  React.useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_PREFIX + localStorageKey, value);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
};

export default useStateWithLocalStorage;
